import axios from 'axios'

// localStorage에서 액세스 토큰 가져오기
function getAccessToken(): string | null {
  return localStorage.getItem('access_token')
}

// 액세스 토큰 저장
export function setAccessToken(token: string): void {
  localStorage.setItem('access_token', token)
}

// 액세스 토큰 삭제
export function removeAccessToken(): void {
  localStorage.removeItem('access_token')
}

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

// Request interceptor - Add Bearer token
api.interceptors.request.use((config) => {
  const token = getAccessToken()
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`
  }
  return config
})

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 토큰 만료 또는 무효 - 로그인 페이지로 리다이렉트
      removeAccessToken()
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)
